import React, { useState, useEffect } from 'react';
import UnIndicator from "../../components/UnIndicator";
import { useHistory, useParams, useLocation } from "react-router-dom";
//import StepZeroITRep from "../../components/StepZero/indexITRep";
import {saveData, stripHtml} from "../Form//utils";
import Loader from "../../components/Loader";
//import { GET_ENDPOINT } from "../../constants";
import ErrorMessage from "../Form/ErrorMessage";
import { useTranslation } from 'react-i18next';
import { COUNTRY, LANGUAGE, SITE } from '../Form/constant';
import UnButton from "../../components/UnButton";
import '../../App.css';
import { API_DOMAIN } from '../../constants';


export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const steps = [
  {
    value: 1,
    label: "Step 1",
  },
  {
    value: 2,
    label: "Step 2",
  },
  {
    value: 3,
    label: "Step 3",
  },
];

const RepIT = () => {
  const params = useParams()
  const history = useHistory();
  const query = useQuery();
  const pharmacistId = query.get('pharmacistId');
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMesage] = useState('');
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isListIdValid, setIsListIdValid] = useState(false);
  const { t } = useTranslation();

  const repListId = params.id ? (params.id * 1) : null;
  

  useEffect(() => {
    // if (pharmacistId && !isDataLoaded) {
    const tempEndPoint = API_DOMAIN + '/api/v1/register/rep/pharmacies?assignedreptoken=' + repListId;
    if (!isDataLoaded) {
      setIsLoading(true);
      // fetch(GET_ENDPOINT.replace('##id##', pharmacistId))
      fetch(tempEndPoint)
        .then((response) => {
          console.log('response: ', response);
          if (response.ok) {
            return response.json();
          } else {
            throw Error('Error happened at fetch');
          }
        })
        .then((json) => {
          console.log('json: ', json);
          setIsDataLoaded(true);
          setData(json.data || json);
        })
        .catch((err) => {setHasError(true); console.log('Was error',err)})
        .finally(() => setIsLoading(false));
    }
  }, [pharmacistId, isDataLoaded, repListId])

  const submit = async function(nextPage, formData = {}) {
        console.log('FORMDATA',formData)
        console.log('HERE',nextPage)
        console.log(saveData);
        stripHtml('sdfsddf');                  
        console.log('HERE',setData);
        setErrorMesage(SITE);
        console.log(params)
        setIsListIdValid(true)
  }
  
  console.log(submit);
  
  const routeHandler = (showList) => {
        return (
            <>
            <div className="flex flex-col md:mx-0 py-10 px-10 bg-white rounded-md w-12/12 md:w-12/12 h-3/6 overflow-y-scroll">
              <h1 className="text-md md:text-xl text-blue-theme font-bold tracking-relax mx-auto">
                {'Pharmacy List'}
              </h1>
              <ul className="mt-6 md:pl-8 list-decimal mb-6">
                {
                  data.map((details)=>{
                    console.log('details: ', details);
                    const { fullAddress, pharmacyName, id} = details;
                    return(
                      <li className="text-blue-theme tracking-wide leading-normal mb-6">
                      <div style={{display: 'flex',flexDirection:'row', flex: 1.0, backgroundColor: 'transparent'}}>
                      <div style={{flex: 0.8,marginRight:10}}>{pharmacyName},{fullAddress}</div>
                      <div style={{flex: 0.2}}>
                        <UnButton
                          title={t('rep.button.edit')}
                          fullWidth={false}
                          position="center"
                          onClick={() => history.push('/rep/form?pharmacyId=' + id)}
                        /></div>
                      </div>
                    </li>
                    )
                  })
                }
                
              </ul>
              <p className="flex flex-wrap text-blue-theme text-sm md:text-base tracking-wide opacity-70 leading-normal flow-root mb-4">
                .
              </p>
             
            </div>
            
          </>
        );
  }

  return (
    <div className="flex flex-col py-10 px-10 bg-white rounded-md w-10/12 md:w-7/12">
      <h1 className="text-xl text-blue-theme font-bold tracking-relax mx-auto mb-6">
        {t('registration.title')}
      </h1>
      {isLoading && (
        <div className={'flex mx-auto'}>
          <Loader />
        </div>
      )}
      {hasError && <ErrorMessage errorMessage={errorMessage} />}
      {!hasError && !isLoading && routeHandler(isListIdValid) }
    </div>

  )
}
export default RepIT;




